//-------------------------------------------
//onload
//-------------------------------------------
window.addEventListener('load', (event) => { 
  setTimeout(() => {
    /** All pages */
    ada_buddha() 
  
    /** PLP */ 
    if (document.body.matches('.template-collection')){      
      ada_shogun()
    }

    /** PAGE */
    if (document.body.matches('.template-page')){
      ada_okeReviews()
      ada_shogun()
      ada_shogun_link()
    }

    /** ACCT */
    if (document.body.matches('.template-register')){
      ada_accountpages()      
    }
   

    /** CONTACT */
    if (window.location.pathname.indexOf('contact') > -1){
      ada_contact()
    }

    /** RECHARGE */     
    if (window.location.pathname.indexOf('recurring/get-subscription-access') > -1){
      ada_recharge()
    }
  }, 2000);
})

//--------------------------------
// helpers
//--------------------------------
function elementFound(selector) { 
  return new Promise((resolve, reject) => {
    let el = document.querySelector(selector)
    if (el) {
      resolve(el)
    }else{
      // reject('ELEMENT NOT FOUND:' +  selector) 
    }
  }) 
}
function add_label(element, id){
  let newlabel = document.createElement("Label");
  newlabel.setAttribute("for", id);
  newlabel.innerHTML = id
  newlabel.classList.add('sr-only')
  element.setAttribute('id', id)
  element.parentNode.appendChild(newlabel)
}
function add_arialabel_to_element(id){
  elementFound(`#${id}`).then(( )=>{
    let elm = document.querySelector(`#${id}`)        
    if (elm) elm.setAttribute('aria-label', id)       
  }).catch(e => console.error('error: '+ e))    
}
//--------------------------------
// okeReviews
//--------------------------------
function ada_okeReviews(){
  let t= 'a.okeReviews-review-reviewer-product-thumbnail'
  elementFound(t).then(( )=>{
    let t_s = document.querySelectorAll(t)       
    setTimeout(() => {  
      t_s.forEach(e=>{
        e.setAttribute('aria-hidden', true)
      })
    }, 0);
  }).catch(e => console.error('error: '+ e))  
}

//--------------------------------
// buddhaapps megamenu
//--------------------------------
function ada_buddha(){
  let t1 = '.mm-image img'
  elementFound(t1).then(( )=>{
    let t1_s = document.querySelectorAll(t1)      
    t1_s.forEach(e=>{ 
      let a = e.closest('a')
      if (a) {
        let a_label = a.getAttribute('aria-label')
        e.setAttribute('alt', a_label) 
      }
    })  
  }).catch(e => console.error('error: '+ e)) 
}

//--------------------------------
// shogun
//--------------------------------
function ada_shogun(){
  let t1 = '.shogun-image-link img'
  elementFound(t1).then(( )=>{
    let t1_s = document.querySelectorAll(t1)  
    t1_s.forEach(e=>{       
      if (e) { 
        if (e.getAttribute('alt') == null || e.getAttribute('alt') == ""){
          e.setAttribute('alt', "coffee am image | shogun ") 
        } 
        let img_link = e.closest(".shogun-image-link")       
        if (img_link){
          if (img_link.getAttribute('aria-label') && img_link.getAttribute('aria-label').length < 1){
            img_link.setAttribute('aria-label', "coffee am image link") 
          }
        }
      }
    })  
  }).catch(e => console.error('error: '+ e)) 
}

//--------------------------------
// Contact page
//--------------------------------
function ada_contact(){ 
  let t2 = 'area'
  elementFound(t2).then(( )=>{
    let elm = document.querySelector(t2)        
    if (elm) elm.setAttribute('alt', 'map area')       
  }).catch(e => console.error('error: '+ e))    
}


//--------------------------------
// Account pages
//--------------------------------
function ada_accountpages(){
  let t1 = '.customr-control-label'
  elementFound(t1).then(( )=>{
    let t1_s = document.querySelectorAll(t1)

    // find these 4 labels, add id to its parent manually
    const array = ['Individual or a Commercial', 'Sign up for', 'may send you special offers', 'Products of interest'];
    const matches = function(txt){
      return array.filter(element => { 
        if (txt.indexOf(element) !== -1) 
          return true;
      });
    }
    t1_s.forEach(e=>{
      let txt = e.innerHTML.trim() 
      if (matches(txt).length > 0 ){ 
        let id = e.getAttribute('for')        
        let target = e.closest('.customr-field')        
        if (target) 
          target.setAttribute("id", id) 
      }
    })
  }).catch(e => console.error('error: '+ e)) 
}  

//--------------------------------
// Recharge
//--------------------------------
function ada_recharge(){  
  // add label
  let t1 = '#customer_email'
  elementFound(t1).then(( )=>{
    let t1_e = document.querySelector(t1)
    if (t1_e){
      t1_e.setAttribute('aria-label','customer email')
    }    
  }).catch(e => console.error('error: '+ e)) 

  // rm duplicated head title
  let t2 = '#site-main > title'
  elementFound(t2).then(( )=>{
    let t2_e = document.querySelector(t2)
    if (t2_e){
      t2_e.remove()
    }    
  }).catch(e => console.error('error: '+ e)) 

}

function ada_shogun_link() { 
  let t2 = '.template-page .shg-category-grid a'
  elementFound(t2).then(() => {
    let elms = document.querySelectorAll(t2)
    elms.forEach(elm => {
      if (elm) {
        if (!elm.getAttribute('href')) {
          elm.setAttribute('href', '#')
        }
      } 
    })              
  }).catch(e => console.error('error: '+ e))    
}
